<template>
  <div class="liquor-category">
    <Header active="/liquor/country" />
    <HeaderSelect :list="headerSelectArray" />

    <div class="image">
      <div class="image-1">
        <img src="/liquor/分类体系.png" />
      </div>
      <div class="image-2">
        <img src="/liquor/分类介绍.png" />
      </div>
    </div>

    <!-- <Sticky /> -->
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import Sticky from "@/components/liquor/Sticky";
import HeaderSelect from "@/components/liquor/HeaderSelect";
import MultiMedia from "@/components/liquor/MultiMedia";

export default {
  name: "LiquorMasterArea",
  components: {
    Header,
    Sticky,
    HeaderSelect,
    MultiMedia
  },
  data() {
    return {
      headerSelectArray: [
        {
          name: "分类体系",
          link: "/liquor/category",
          active: true
        },
        {
          name: "主力产区",
          link: "/liquor/country",
          active: false
        },
        {
          name: "酿造工艺",
          link: "/liquor/brewing",
          active: false
        }
      ],
      countryList: [],
      areaList: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let response;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorArea",
        methodName: "retrieve",
        params: {
          numPerPage: 10000
        }
      });
      this.areaList = response.results;

      response = await this.ajax.doPost({
        packageName: "liquor",
        className: "liquorCountry",
        methodName: "retrieve",
        params: {
          focus: true
        }
      });

      this.countryList = response.results.map(e => {
        return {
          ...e,
          areaList: this.areaList.filter(a => a.country === e.country)
        };
      });
    },
    goto(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
.liquor-category {
  width: 100%;
  margin: 160px 0;

  .image {
    width: 100%;
    // display: flex;
    // justify-content: center;
    // flex-direction: column;
    .image-1 {
      margin: 0 auto;
      width: 100%;
      height: 947px;
      background-image: url(/liquor/体系背景.png);
      background-size: 100% 947px;
      background-position: center;
      background-repeat: no-repeat;

      img {
        display: block;
        width: 1290px;
        margin: 0 auto;
      }
    }

    .image-2 {
      margin: 0 auto;
      width: 100%;
      margin-top: 70px;
      img {
        display: block;
        width: 1106px;
        margin: 0 auto;
      }
    }
  }
}
</style>